import { observer } from "mobx-react-lite";
import React from "react";

import { TextBadge, TextBadgeColor, TextBadgeSize } from "@bps/fluent-ui";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";

interface ClaimOnsetBadgeProps {
  episodeOfCare: EpisodeOfCare;
}

export const ClaimOnsetBadge: React.FC<ClaimOnsetBadgeProps> = observer(
  ({ episodeOfCare: { injuryDate } }) => {
    if (!injuryDate) return null;

    return (
      <TextBadge
        badgeColor={TextBadgeColor.lightGrey}
        badgeSize={TextBadgeSize.medium}
      >
        Onset: {injuryDate.toDayDefaultFormat()}
      </TextBadge>
    );
  }
);
